module.exports = __webpack_public_path__ + "static/media/report_icon.22647fdf.png";